<template>
  <div>


    <!-- <b-navbar-toggle target="side-nav" style="float:left;">
        <template>
          <div style="border:solid 1px black;border-radius:3px;font-size: 1.5rem;">
          <b-icon icon="list"></b-icon>
        </div>
        </template>
      </b-navbar-toggle> -->

<b-container class="side-n" id=""  >
  <!-- <b-collapse id="side-nav" is-nav class="nav-bgcolor"> -->

  <!-- <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('office')" block squared id="boffice" class=" btn-color btn-color-active">
        Registered Office
      </b-button></b-col>
  </b-row> -->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('customerCare')" block squared id="bcustomerCare" class=" btn-color btn-color-active">
    এপিডিচিএল গ্ৰাহক সেৱা
  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('kofficial')" block squared id="bkofficial" class=" btn-color">
    মূখ্য বিষয়াসকলৰ (মুখ্য কাৰ্যালয়)যোগাযোগ
  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button  @click="goto('zone')" block squared id="bzone" class=" btn-color">
      মণ্ডলসমূহৰ যোগাযোগ</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('circle')" block squared id="bcircle" class=" btn-color">
     চক্ৰসমূহৰ যোগাযোগ</b-button></b-col>
  </b-row>

  <b-row class="custom-row">
    <b-col ><b-button @click="goto('division')" block squared id="bdivision" class=" btn-color">
    সংমণ্ডলসমূহৰ যোগাযোগ</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('subdivision')" block squared id="bsubdivision" class=" btn-color">
   উপ-সংমণ্ডলসমূহৰ যোগাযোগ</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('irca')" block squared id="birca" class=" btn-color">
      আই.আৰ.চি.এ. সমূহৰ যোগাযোগ
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    
    <b-col ><b-button @click="goto('tc')" block squared id="btc" class=" btn-color">
    টি এণ্ড চি সংমণ্ডলসমূহৰ যোগাযোগ</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('agm')" block squared id="bagm" class=" btn-color">
    জিলাভিত্তিক এজিএম(প্ৰকল্প) সমূহৰ যোগাযোগ</b-button></b-col>
  </b-row>
<!-- </b-collapse> -->
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
  /*goto(refName) {
     var element=document.getElementById(refName);
     var btn_id='b' + refName;
     var btn=document.getElementById(btn_id);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });
     document.querySelector(".btn-color-active").classList.remove("btn-color-active");
     btn.classList.add("btn-color-active");
   }*/

   goto(refName) {
  
  document.querySelectorAll('.section-content').forEach(div => {
    div.style.display = 'none';
  });

  
  var element = document.getElementById(refName);
  element.style.display = 'block';


  element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });

  // Button highlighting
  var btn_id = 'b' + refName;
  var btn = document.getElementById(btn_id);
  document.querySelector(".btn-color-active").classList.remove("btn-color-active");
  btn.classList.add("btn-color-active");
}

  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;
 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd     ;
  border-color: #0277bd     ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1    ;
  border-color: #0288d1    ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
